import React from "react";
import styles from "../../assets/styles/_hairCheck.module.scss";
import BtnLearnMore from "../common/btnLearnMore";
import { useNavigate } from "react-router-dom";

const Step3 = ({ type, product, setStep }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.step3}>
      <div className={styles.txt1}>{product.txt1}</div>
      <div className={styles.title} dangerouslySetInnerHTML={{ __html: product.title_product }}></div>
      <div
        className={styles.txt2}
        style={{ fontSize: product.fontSize }}
        dangerouslySetInnerHTML={{ __html: product.des_product }}
      ></div>
      <div className={styles.images}>
        {product.imgs.map((img, index) => (
          <img key={index} src={img} alt="product" />
        ))}
      </div>
      <div className={styles.txt3} dangerouslySetInnerHTML={{ __html: product.featured_products }}></div>
      <div className={styles.btnWrap}>
        <BtnLearnMore color={type === "pink" ? "#FDAFE980" : "#5CCEFF66"} baseColor={type === "pink" ? "#fdafe9" : "#5CCEFF"} sizeSmall
          action={() => {
            if (type === "pink") {
              navigate("/product-detail-deep");
            }
            if (type === "blue") {
              navigate("/product-detail-sleek");
            }
          }}
        >
          LEARN MORE
        </BtnLearnMore>
        <button className={styles.buttonBack} onClick={() => setStep(0)}>
          再診断する
        </button>
      </div>
    </div>
  );
};

export default Step3;
